export default "__VITE_ASSET__1384e87f__"